import { AbstractStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ImpiantiTermiciActions";
import { ImpiantoDto } from "../generated";
import ImpiantiTermiciActions from "./ImpiantiTermiciActions";

class ImpiantiTermiciStore extends AbstractStore<ImpiantoDto> {
    constructor() {
        super(x => x.idImpianto.toString());
        Dispatcher
            .onfunction(Actions.getImpiantoTermico, result => this.updateOrAdd(result))
            .onfunction(Actions.add, result => this.add(result))
            .onfunction(Actions.update, result => this.updateOrAdd(result))
            .onfunction(Actions.delete, result => result.deleteOk ? this.delete(result.impiantoId.toString()) : () => { })
    }

    public use = (IdImpianto: number) => this.useWithAction(() => ImpiantiTermiciActions.getImpiantoTermico(IdImpianto), IdImpianto?.toString() ?? null);


}

export default new ImpiantiTermiciStore()
